import { ApiError } from './ApiError';
import { t } from 'i18next';

export function isNotFoundError(error: Error): error is NotFoundError {
  return error.constructor === NotFoundError;
}

export class NotFoundError extends ApiError {
  static async create(response: Response) {
    const errorResponse = await this.extractError(response);

    const newError = new NotFoundError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      t('Error.Category.NotFound.message');

    return newError;
  }
}
